var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("groups", {
        ref: "groups",
        attrs: {
          styles: _vm.styles,
          groups: _vm.allGroups,
          "all-users": _vm.allUsers,
          "all-categories": _vm.allCategories,
          "allow-user-selection": false,
          maxDepth: 0
        },
        on: { creategroup: _vm.onCreateGroup, updategroup: _vm.onUpdateGroup }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-action" }, [
        _c(
          "button",
          {
            staticClass: "continue simple",
            on: { click: _vm.updatePendingGroups }
          },
          [_vm._v("Continue")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { padding: "12px" } }, [
      _vm._v(
        "\n        Before you invite your Team, you can create User Groups to decide \n        what kind of documents your Team members will have access to. \n        "
      ),
      _c("br"),
      _vm._v(
        ' We have made two default groups to get you started, \n        a  restricted group for "Management"  and one that "All users" will be part of. \n    '
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01c635b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c635b5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/Groups.vue
// module id = 492
// module chunks = 0